<!-- <div class="dialog"> -->
	<div class="modal__header">
		<h2 class="title" id="modal__title">{{ 'modals.expirateAlert.title.sessionExpired' | ibeadmin: 'sync' }}</h2>
	</div>
	<div class="modal__body sl--scrollable">
		<ng-container *ngIf="!isLoading">
			{{ 'modals.expirateAlert.text.sessionAboutToExpire' | ibeadmin: 'sync' }}
			<br/><br/>
			{{ 'modals.expirateAlert.text.timeRemaining' | ibeadmin: 'sync' }} : <countdown [config]="config" (finished)="INDRA_handleCountdownFinish()"></countdown>
		</ng-container>

		<div class="renew-loader" *ngIf="isLoading">
			{{ 'modals.expirateAlert.text.pleaseWait' | ibeadmin: 'sync' }}
			<div class="wrap">
				<app-loading></app-loading>
			</div>
		</div>
	</div>
	<div class="modal__footer" *ngIf="!isLoading">
		<div *ngIf="!isLoading" class="modal__footer-action positive-action">
			<button (click)="INDRA_sessionAccept()" class="button button--small button-accent button--icon-right">
				{{ 'modals.expirateAlert.text.continueOnThisPage' | ibeadmin: 'sync' }}
				<app-svg svg="icons.svg#general--arrow--right"></app-svg>
			</button>
		</div>
	</div>
<!-- </div> -->
